import type { TFunction } from "i18next";

/** Affiche le libellé traduit pour un opérateur logique stocké (AND/OR). */
export function logicalOperatorLabel(
  op: string | undefined,
  t: TFunction,
): string {
  const u = (op ?? "AND").trim().toUpperCase();
  if (u === "OR") return t("step5Validation.operators.or");
  if (u === "AND") return t("step5Validation.operators.and");
  return (op ?? "").trim() || t("step5Validation.operators.and");
}
